import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import moment from 'moment';
import ModalReceive from './ModalReceive';
import { receiptColumn, changeStatus, getAllReceipt, updateReceipt, massUpdateReceipt } from './actions';
import ModalHistory from './ModalHistory';

//to keep tempDat of Current PAGE data
let currentPageData = [];

class Receipt extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            receipts: [],
            modalReceive: false,
            isMassUpdate: false,
            selectedReceipt: [],
            modalData: {},
            isCheckedAll: false,
            selectedId: '',
            modalHistory: false,
            massReceiptUpdates: [],
        };
        this.getAllReceipt = getAllReceipt.bind(this);
        this.save = this.save.bind(this);
        this.selectReceipt = this.selectReceipt.bind(this);
        this.massUpdateReceipt = massUpdateReceipt.bind(this);
        this.updateReceipt = updateReceipt.bind(this);
        this.receiptColumn = receiptColumn.bind(this);
        this.changeStatus = changeStatus.bind(this);
        this.toggleCheckedList = this.toggleCheckedList.bind(this);
        this.onTableViewChange = this.onTableViewChange.bind(this);
        this.reactTable = React.createRef();
        this.customFilter = this.customFilter.bind(this);
    }

    async componentWillMount() {
        try {
            this.setState({ loading: true });
            const receiptList = await this.getAllReceipt();
            let temp = [];
            let index = 0;
            if (this.props.user.loggedInUser.Partner_Authority__c === null) {
                if (receiptList.records !== undefined) {
                    for (let i = 0; i < receiptList.records.length; i++) {
                        if (receiptList.records[i].Status__c === 'Disbursed' || receiptList.records[i].Status__c === 'Received by Beneficiary') {
                            currentPageData.push(receiptList.records[i])
                            currentPageData[index].Status__c = receiptList.records[i].Status__c === 'Disbursed' ? 'Pending' : 'Received';
                            index++
                        }
                    }
                }
                temp = currentPageData;
            }
            else {
                if (receiptList.records.length > 9) {
                    for (let i = 0; i < receiptList.records.length; i++) {
                        currentPageData.push(receiptList.records[i]);
                    }
                }
                temp = receiptList.records;
            }

            if (receiptList.records !== undefined) {
                this.setState({ receipts: temp });
            }
            this.setState({ loading: false });
        } catch (error) {
            swal({
                title: 'AN error occured',
                text: error.toString(),
            });
            this.setState({ loading: false });
        }
    }

    // function to get current page data
    onTableViewChange() {
        const current = this.reactTable.current;
        if (current) {
            const page = current.state.page;
            const pageSize = current.state.pageSize;
            const allData = current.getResolvedState().sortedData;
            const startIdx = page * pageSize;
            currentPageData = allData.slice(startIdx, startIdx + pageSize).map((item) => item._original);
        }
    }

    // to toogle  whole data or selected receipt
    toggleCheckedList(e) {
        if (e.target.value === 'on') {
            this.setState({
                isCheckedAll: !this.state.isCheckedAll,
            }, () => {
                if (this.state.isCheckedAll) {
                    const selectedReceipt = [];
                    for (let i = 0; i < currentPageData.length; i++) {
                        if (currentPageData[i].Status__c === 'Disbursed') {
                            selectedReceipt.push(currentPageData[i].Id);
                        }
                    }
                    this.setState({
                        selectedReceipt,
                    });
                }
                else {
                    this.setState({
                        selectedReceipt: [],
                    });
                }
            });
        }
        else {
            const { selectedReceipt } = this.state;
            const index = selectedReceipt.indexOf(e.target.value);
            if (index > -1) selectedReceipt.splice(index, 1);
            else selectedReceipt.push(e.target.value);
            this.setState({ selectedReceipt });
        }
    }


    async save(e) {
        e.preventDefault();
        if (this.state.loading) return;
        let status = true;
        let reqFields = ['Given_Amount__c', 'Date_Received__c', 'Mode_of_Payment__c'];
        const valid = [];

        if (!this.state.isMassUpdate) {
            reqFields.map((reqField) => {
                if (this.state.modalData[reqField] === undefined || this.state.modalData[reqField] === '') {
                    const theFields = reqFields.map(field => field.replace('__c', '').replace(/_/g, ' ')).join(' or ');
                    swal({
                        // text: `${reqField.replace('__c', '').replace(/_/g, ' ')} could not be empty`,
                        // text: 'Given Amount" or "Date Received" or "Mode of Payment" cannot be empty!',
                        text: `${theFields} cannot be empty!`,
                        title: 'missing fields!!',
                    });
                    valid.push('false');
                }
            });
        }

        this.state.receipts.map((receipt) => {
            if (this.state.selectedReceipt.indexOf(receipt.Id) > -1) {
                if (receipt.Approved_Amount__c < this.state.modalData.Given_Amount__c) {
                    status = false;
                }
            }
        });
        if (status === false) {
            swal({
                text: 'The amount given is too much for some receipts',
                title: 'Invalid Given Amount',
            });
            return;
        }
        if (!valid.includes('false')) {
            try {
                this.setState({ loading: true });

                const reply = this.state.isMassUpdate ? await this.massUpdateReceipt() : await this.updateReceipt();
                swal({
                    title: 'Receipt updated',
                    text: reply.message,
                });
                this.setState({ selectedReceipt: [], modalData: {}, modalReceive: false });
                this.componentWillMount();
            } catch (error) {
                swal({
                    title: 'An error occured',
                    text: error.message,
                });
                this.setState({ loading: false, modalData: {} });
            }
        }
    }

    selectReceipt(id = null) {
        let { selectedReceipt } = this.state;
        const index = selectedReceipt.indexOf(id);
        if (id === 'all') {
            if (selectedReceipt.length > 0) selectedReceipt = [];
            else {
                this.state.receipts.map(receipt => (receipt.Status__c === 'Disbursed' ? selectedReceipt.push(receipt.Id) : null));
            }
        } else if (index > -1) {
            selectedReceipt.splice(index, 1);
        } else {
            selectedReceipt.push(id);
        }
        this.setState({
            selectedReceipt,
        });
    }


    customFilter (filter, row) {
        const id = filter.pivotId || filter.id;
        if (row[id] !== null && typeof row[id] === "string") {
            return (row[id] !== undefined
                ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                : true);
        }
        return this;
    }

    render() {
        return (
            <div className="row">
                <div className="card list">
                    <p style={{ textAlign: 'center' }}>
                        {this.state.loading ? <i className="fa fa-5x fa-spinner fa-spin" /> : null}
                    </p>
                    <div className="row">
                        <div className="col-lg-6 col-xs-12">
                            <h3>Receipt</h3>
                        </div>
                        <div className="col-lg-6 col-xs-12 pull-right" style={{ textAlign: 'right' }}>
                            {this.props.user.loggedInUser.Partner_Authority__c !== null ? <button
                                className="btn btn-default"
                                onClick={() => {
                                    if (this.state.selectedReceipt.length === 0) return;
                                    this.setState({
                                        modalReceive: true,
                                        isMassUpdate: true,
                                        modalData: {
                                            Date_Received__c: moment(),
                                        },
                                    });
                                }}
                            >
                                <i className="fa fa-paper-plane" /> Mass Update Receive
                            </button> : null}
                        </div>
                    </div>
                    <div className="row">
                        <ReactTable
                            data={this.state.receipts}
                            columns={this.receiptColumn()}
                            sortable
                            ref={this.reactTable}
                            defaultFilterMethod={this.customFilter}
                            onPageChange={this.onTableViewChange}
                            onPageSizeChange={this.onTableViewChange}
                            onSortedChange={this.onTableViewChange}
                            onFilteredChange={this.onTableViewChange}
                            filterable
                            getTdProps={() => ({
                                style: {
                                    border: '1px solid #eee',
                                    padding: 10,
                                    fontSize: 14,
                                },
                            })}
                            defaultPageSize={10}
                        />
                    </div>
                    <ModalReceive
                        visible={this.state.modalReceive}
                        isMassUpdate={this.state.isMassUpdate}
                        close={() => this.setState({
                            modalReceive: false,
                            modalData: {},
                            isMassUpdate: false,
                        })}
                        save={this.save}
                        onFormChanged={(value, attribute) => this.setState({
                            modalData: {
                                ...this.state.modalData,
                                [attribute]: value,
                            },
                        })}
                        updateMass={value => this.setState({
                            massReceiptUpdates: value,
                        })}
                        massReceiptUpdates={this.state.massReceiptUpdates}
                        loading={this.state.loading}
                        formValue={this.state.modalData}
                        receipts={this.state.receipts}
                        selectedReceipt={this.state.selectedReceipt}
                    />
                    <ModalHistory
                        token={this.props.user.siteToken.hash}
                        id={this.state.selectedId}
                        visible={this.state.modalHistory}
                        close={() => this.setState({ modalHistory: false })}
                    />
                </div>
            </div>
        );
    }
}

Receipt.propTypes = {
    user: PropTypes.object.isRequired,
    salesforce: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({

    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    receiptStatusList: state.objectInfo.Receipt__c.filter(obj => obj.name === 'Status__c').length ? state.objectInfo.Receipt__c.filter(obj => obj.name === 'Status__c')[0].picklistValues : [],
});
export default connect(mapStateToProps, mapDispatchToProps)(Receipt);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Receipt/index.js
// module id = 992
// module chunks = 0